var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "financial-terminal"
  }, [_c("section", {
    staticClass: "financial-terminal__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "PC金融终端2.0",
      description: "金融终端2.0集行情、交易、投资、理财、资讯为一体的综合投资理财网上交易终端，\n      主打经典交互及资深股民，其交易、工具、数据一站式整合的布局更符合多数老股民的使用习惯。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "financial-terminal__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "financial-terminal__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "financial-terminal__skill-wrapper"
  }, [_c("Skill", {
    staticClass: "area",
    attrs: {
      skillList: _vm.skillList
    }
  })], 1), _c("section", {
    staticClass: "financial-terminal__cases-wrapper"
  }, [_c("Cases")], 1), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };